/** Ошибки сразу у многих фото — одно перечитывание истории, а не запрос на каждый пузырь. */
export const MEDIA_ERROR_REFRESH_GAP_MS = 30_000;

export function throttleMediaRefresh(refresh: () => void, now: () => number = Date.now): () => boolean {
  let lastAt = Number.NEGATIVE_INFINITY;
  return () => {
    const at = now();
    if (at - lastAt < MEDIA_ERROR_REFRESH_GAP_MS) return false;
    lastAt = at;
    refresh();
    return true;
  };
}
